module.exports = __webpack_public_path__ + "img/07_BC8_sample_the_shrubs.8a2b3a75.jpg";